import { useCallback, useState } from 'react';

import Modal from '../../ui/components/modal';

export function useModal() {
  const [open, setOpen] = useState(false);
  const [props, setProps] = useState();

  const toggleOpen = useCallback(
    (isOpen = false, item = undefined) => {
      let isInitOpen = false;
      if (typeof isOpen === 'boolean') {
        isInitOpen = isOpen === false ? !open : isOpen;
      }
      setOpen(isInitOpen);
      item && setProps(item);
    },
    [open],
  );

  const renderModal = useCallback(
    (getChildren) => {
      return (
        <Modal isOpen={open} modalClosed={toggleOpen} disable>
          {getChildren(props)}
        </Modal>
      );
    },
    [open, props, toggleOpen],
  );

  return {
    renderModal,
    toggleOpen,
    setInitProps: setProps,
  };
}
